/* tslint:disable */
/* eslint-disable */

import React, { FunctionComponent } from 'react';
import { ViewProps } from 'react-native';
import { Svg, GProps, Path } from 'react-native-svg';
import { getIconColor } from './helper';

interface Props extends GProps, ViewProps {
  size?: number;
  color?: string | string[];
}

let BookmarkO: FunctionComponent<Props> = ({ size, color, ...rest }) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} {...rest}>
      <Path
        d="M227.555328 113.777664V908.60544l212.70016-173.191168c41.846784-34.0736 101.87264-34.064384 143.70816 0.021504l212.48 173.121536V113.777664H227.556352z m0-56.88832h568.889344c31.418368 0 56.88832 25.469952 56.88832 56.88832v794.779648c0 31.419392-25.469952 56.889344-56.88832 56.889344a56.889344 56.889344 0 0 1-35.934208-12.785664l-212.48-173.121536c-20.918272-17.043456-50.930688-17.047552-71.85408-0.01024L263.4752 952.71936c-24.364032 19.837952-60.196864 16.16896-80.03584-8.194048a56.889344 56.889344 0 0 1-12.773376-35.919872V113.77664c0-31.418368 25.469952-56.88832 56.88832-56.88832z"
        fill={getIconColor(color, 0, '#333333')}
      />
      <Path
        d="M654.222336 369.777664c15.709184 0 28.444672 12.735488 28.444672 28.444672 0 93.314048-74.89024 169.136128-167.84384 170.643456l-2.823168 0.023552c-94.08512 0-170.38848-76.132352-170.665984-170.151936v-0.515072c0-15.709184 12.734464-28.444672 28.443648-28.444672 15.709184 0 28.444672 12.735488 28.444672 28.444672C398.222336 461.060096 449.16224 512 512 512s113.777664-50.939904 113.777664-113.777664l0.004096-0.47104c0.25088-15.492096 12.888064-27.973632 28.440576-27.973632z"
        fill={getIconColor(color, 1, '#333333')}
      />
    </Svg>
  );
};

BookmarkO.defaultProps = {
  size: 18,
};

BookmarkO = React.memo ? React.memo(BookmarkO) : BookmarkO;

export default BookmarkO;
